// configuration

const DEBUG_MODE = false;





const DEBUG_BASE_URL = "https://test-api.nasipaipon.com";
export const BASE_URL = DEBUG_MODE? DEBUG_BASE_URL: "https://api.nasipaipon.com";

export const URL_LOGIN = BASE_URL + "/api/user/login";
export const URL_TOKEN_TEST = BASE_URL + "/api/hello";
export const URL_GET_ALL_USERS = BASE_URL+"/api/user/list";
export const URL_GET_ALL_VENDORS_GIFT = BASE_URL+"/api/referral-system/get-stats-admin";

export const URL_GET_ALL_REGIONS = BASE_URL  +"/api/regions"
export const URL_GET_ALL_KITCHENS = BASE_URL + "/api/panel/kitchens"
export const URL_GET_ALL_ORDERS = BASE_URL+"/api/orders";
export const IMAGE_BASE_URL = BASE_URL  +"/api/files?path=";
export const URL_GET_ALL_SETTINGS = BASE_URL +"/api/panel/settings"
export const URL_KITCHEN_APPROVE = BASE_URL +"/api/kitchen/approve"
export const URL_KITCHEN_REJECT = BASE_URL+"/api/kitchen/reject";
export const URL_POST_UPDATE_HOLIDAYS = BASE_URL+"/api/panel/holidays/update";
export const URL_CREATE_STAFF_ACCOUNT = BASE_URL+"/api/panel/create_account";

export const URL_KITCHEN_ACTIVE = BASE_URL+"/api/kitchen/active";
export const URL_KITCHEN_SUSPEND = BASE_URL+"/api/kitchen/suspend";
export const URL_POST_UPDATE_FEES = BASE_URL+"/api/fees/all";
export const URL_POST_UPDATE_META = BASE_URL+"/api/fees/meta";
export const URL_POST_SEND_NOTIFICATION = BASE_URL + "/api/panel/send_push";
export const URL_POST_UPDATE_KITCHEN_INFO=BASE_URL + "/api/info?type=kitchen";
export const URL_POST_UPDATE_USER_INFO=BASE_URL + "/api/info?type=user";
export const URL_POST_UPDATE_AGENT_INFO=BASE_URL + "/api/info?type=agent";
export const URL_POST_UPDATE_FAQS = BASE_URL+"/api/faqs/update"
export const URL_GET_COMISSIONS = BASE_URL+"/api/comissions"
export const URL_GET_WALLETS = BASE_URL+"/api/wallets"
export const URL_PAY_TO_VENDOR = BASE_URL+"/api/wallets/pay_to_vendor"
export const URL_POST_CREATE_GIFT =BASE_URL + "/api/prizes/create";
export const URL_POST_UPDATE_GIFT =BASE_URL + "/api/prizes/update";
export const URL_DELETE_GIFT =BASE_URL + "/api/prizes/delete";



export const URL_POST_CREATE_CHAT =BASE_URL + "/api/chats/create";
export const URL_GET_DELETE_CHAT =BASE_URL + "/api/chat/delete/";
export const URL_GET_DELETE_STAFF_ACCOUNT =BASE_URL + "/api/panel/delete_account/";
export const URL_GET_CHANGE_PASSWORD_STAFF =BASE_URL + "/api/panel/change_account_password/";

export const URL_POST_CREATE_BULK_CHAT =BASE_URL + "/api/chats/create/bulk";


export const URL_GET_INBOX_DATA = BASE_URL + "/api/panel/inbox";